// extracted by mini-css-extract-plugin
export var o_cards2 = "cards2-module--o_cards2--05101";
export var o_cards2__bg = "cards2-module--o_cards2__bg--00654";
export var o_cards2__card = "cards2-module--o_cards2__card--1a95a";
export var o_cards2__cards = "cards2-module--o_cards2__cards--2d217";
export var o_cards2__modal = "cards2-module--o_cards2__modal--1bdf2";